import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in
  const token = localStorage.getItem(TOKEN_KEY);

  const check = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, refresh: check }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
